/* ========== ADMIN FUNCTIONS ========== */

async function bondTellerSetBeneficiary(contracts, contractName, beneficiary) {
  const teller = contracts.getContractByName(contractName);
  return await teller.setBeneficiary(beneficiary);
}

async function bondTellerSetReferrerFee(contracts, contractName, fee) {
  const teller = contracts.getContractByName(contractName);
  return await teller.setReferrerFee(fee);
}

async function bondTellerSetProtocolFee(contracts, contractName, fee) {
  const teller = contracts.getContractByName(contractName);
  return await teller.setProtocolFee(fee);
}

async function bondTellerSetCreateFeeDiscount(contracts, contractName, discount) {
  const teller = contracts.getContractByName(contractName);
  return await teller.setCreateFeeDiscount(discount);
}

/* ========== VIEW FUNCTIONS ========== */

async function bondTellerGetProtocolFee(contracts, contractName) {
  const teller = contracts.getContractByName(contractName);
  return await teller.protocolFee();
}

async function bondTellerGetCreateFeeDiscount(contracts, contractName) {
  const teller = contracts.getContractByName(contractName);
  return await teller.createFeeDiscount();
}

async function bondTellerGetFee(contracts, contractName, referrer) {
  const teller = contracts.getContractByName(contractName);
  return await teller.getFee(referrer);
}

async function bondTellerGetBeneficiary(contracts, contractName) {
  const teller = contracts.getContractByName(contractName);
  return await teller.beneficiary();
}

/* ========== USER FUNCTIONS ========== */

async function bondTellerPurchase(
  contracts,
  contractName,
  recipient,
  referrer,
  id,
  amount,
  minAmountOut,
  optionalArgs = {}
) {
  const teller = contracts.getContractByName(contractName);
  return await teller.purchase(recipient, referrer, id, amount, minAmountOut, optionalArgs);
}

async function bondTellerCloseMarket(contracts, contractName, id) {
  const teller = contracts.getContractByName(contractName);
  return await teller.closeMarket(id);
}

/* ========== CALLDATA FUNCTIONS ========== */

async function bondTellerSetBeneficiaryCalldata(contracts, contractName, beneficiary) {
  const teller = contracts.getContractByName(contractName);
  return await teller.populateTransaction.setBeneficiary(beneficiary);
}

module.exports = {
  bondTellerSetBeneficiary,
  bondTellerSetReferrerFee,
  bondTellerSetProtocolFee,
  bondTellerSetCreateFeeDiscount,
  bondTellerGetProtocolFee,
  bondTellerGetCreateFeeDiscount,
  bondTellerGetFee,
  bondTellerGetBeneficiary,
  bondTellerPurchase,
  bondTellerCloseMarket,
  bondTellerSetBeneficiaryCalldata,
};
